import * as z from "zod";
import { requiredErrorMessage } from "./error-messages";

/**
 * Numeric form fields: HTML `type="number"` and Pydantic Decimal JSON are strings.
 * Empty stays empty (required error); non-empty strings coerce on submit.
 */
export const requiredNumberSchema = (schema: z.ZodNumber) =>
  z
    .union([z.string().min(1, { message: requiredErrorMessage }), z.number()])
    .transform((val: string | number) =>
      typeof val === "string" ? Number(val) : val
    )
    .pipe(schema);
